import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GridLegacy, IconButton, List, ListItem, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";

export default function ChildProducts() {
  const { control } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "products",
    keyName: "key",
  });

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <List>
              <ListItem>
                <GridLegacy container>
                  <GridLegacy item xs={4}>
                    <TranslationWrapper tKey={"Product name"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Product default sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <TranslationWrapper tKey={"Sort key"} />
                  </GridLegacy>
                  <GridLegacy item xs={4} />
                </GridLegacy>
              </ListItem>

              {fields.map((field, index) => {
                return (
                  <ListItem>
                    <GridLegacy container>
                      <GridLegacy item xs={4}>
                        <Typography style={{ margin: "0 16px" }}>{field.naam}</Typography>
                      </GridLegacy>

                      <GridLegacy item xs={4}>
                        <IconButton
                          onClick={() => {
                            remove(index);
                          }}
                        >
                          <Delete />
                        </IconButton>

                        <Link to={`/manager/producten/${field.id}/edit`}>
                          <Tooltip
                            classes={{}}
                            placement={"bottom"}
                            title={
                              <TranslationWrapper tDefault={"View Product"} tKey={"global.jamezzTable.viewProduct"} />
                            }
                          >
                            <Button color={"success"} simple>
                              <Edit />
                            </Button>
                          </Tooltip>
                        </Link>
                      </GridLegacy>
                    </GridLegacy>
                  </ListItem>
                );
              })}
            </List>

            {/*</div>*/}
            {/*)}*/}
            {/*</Draggable>*/}
            {/*))}*/}
            {/*{provided.placeholder}*/}
            {/*</Box>*/}
            {/*)}*/}
            {/*</Droppable>*/}
            {/*</DragDropContext>*/}

            {/*<AsyncRelationField*/}
            {/*  // fieldProps={fieldProps}*/}
            {/*  key={"child_products" + menukaartVestigingId}*/}
            {/*  name={"child_products"}*/}
            {/*  tKey={"producten.form.childProducts"}*/}
            {/*  tDefault={"Option Items"}*/}
            {/*  async={{*/}
            {/*    url:*/}
            {/*      "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +*/}
            {/*      menukaartVestigingId,*/}
            {/*    searchField: "naam",*/}
            {/*  }}*/}
            {/*  multiple={true}*/}
            {/*/>*/}
          </GridLegacy>
        </GridLegacy>

        <AddChildProduct append={append} />
      </CardBody>
    </Card>
  );
}

function AddChildProduct({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [product, setProduct] = useState(null);
  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/producten/search?fields=id as value,id,naam as label,vestiging_id,naam,sortkey&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
          searchField: "naam",
          perPage: 20,
          // extraFilters: { vestiging_id: { name: "vestiging_id", value: "vestiging_id" } },
        }}
        key={menukaartVestigingId}
        onChange={(e, option) => {
          setProduct(option);
        }}
        placeholder={getTranslation("Find product")}
        value={product}
      />
      <Button
        disabled={!product}
        onClick={() => {
          setProduct(null);
          append(product);
        }}
      >
        <TranslationWrapper tKey={"Add product"} />
      </Button>
    </>
  );
}
